import { CellTypeNames } from '../CellTypeConstants';
import { CellData, CellTypeObject, TypedCellData } from '../TableTypes';
import { prop } from '../../utils/immutableHelper';

export const getCellValue = prop('value');
export const getCellResultValue = prop('resultValue');

export const getRowCount = <T>(data: Array<Array<T>>): number => (data || []).length;
export const getColumnCount = <T>(data: Array<Array<T>>): number => (data?.[0] || []).length;

// Cell Formulas

export const isFormulaCell = (cellData: CellData): boolean => {
    const cellValue = getCellValue(cellData);
    return !!cellValue && cellValue.toString().startsWith('=');
};

// Cell Types

type NumericCellTypeName = CellTypeNames.CURRENCY | CellTypeNames.NUMBER | CellTypeNames.PERCENTAGE;
type LocaleSpecificCellTypeName = NumericCellTypeName | CellTypeNames.DATE_TIME;

export const isCellOfType =
    <CellTypeNameType extends CellTypeObject['name']>(cellTypeName: CellTypeNameType) =>
    (cellData?: CellData): cellData is TypedCellData<Extract<CellTypeObject, { name: CellTypeNameType }>> =>
        cellData?.type?.name === cellTypeName;

export const isCellTypeAuto = (cellData?: CellData): boolean =>
    !cellData?.type || (cellData.type.name as CellTypeNames) === CellTypeNames.AUTO;
export const isCellTypeText = isCellOfType(CellTypeNames.TEXT);
export const isCellTypeNumber = isCellOfType(CellTypeNames.NUMBER);
export const isCellTypeCurrency = isCellOfType(CellTypeNames.CURRENCY);
export const isCellTypePercentage = isCellOfType(CellTypeNames.PERCENTAGE);
export const isCellTypeDateTime = isCellOfType(CellTypeNames.DATE_TIME);
export const isCellTypeCheckbox = isCellOfType(CellTypeNames.CHECKBOX);

export const isCellTypeNumeric = (
    cellTypeName: CellTypeNames | undefined = CellTypeNames.AUTO,
): cellTypeName is NumericCellTypeName =>
    [CellTypeNames.CURRENCY, CellTypeNames.NUMBER, CellTypeNames.PERCENTAGE].includes(cellTypeName);

export const isCellTypeLocaleSpecific = (
    cellData?: CellData,
): cellData is TypedCellData<Extract<CellTypeObject, { name: LocaleSpecificCellTypeName }>> =>
    isCellTypeNumber(cellData) ||
    isCellTypeCurrency(cellData) ||
    isCellTypePercentage(cellData) ||
    isCellTypeDateTime(cellData);
